import COLORS from "./colors";

const primary = {
  main: COLORS.primary,
  dark: COLORS.primaryPressed,
  contrastText: "#fff"
};

export default {
  palette: {
    primary,
    secondary: primary
  },
  typography: {
    title: {
      fontWeight: 400
    }
  },
  overrides: {
    MuiCard: {
      root: {
        position: "relative",
        overflow: "auto",
        borderRadius: 14,
        boxShadow: "0 4px 16px rgba(10, 40, 70, 0.08)"
      }
    },
    MuiButton: {
      root: {
        borderRadius: 10,
        fontWeight: 600,
        textTransform: "none"
      },
      contained: {
        boxShadow: "none",
        "&:active": {
          boxShadow: "none"
        }
      },
      raised: {
        boxShadow: "none",
        "&:active": {
          boxShadow: "none"
        }
      }
    },
    MuiTab: {
      root: {
        minWidth: 0,
        fontWeight: 600,
        textTransform: "none",
        "@media (min-width: 960px)": {
          minWidth: 0,
          fontSize: 14
        }
      }
    },
    // tighter vertical spacing between form fields (Material UI default is 16 / 8)
    MuiFormControl: {
      marginNormal: {
        marginTop: 6,
        marginBottom: 4
      }
    },
    MuiInput: {
      root: {
        boxSizing: "border-box",
        padding: "6px 12px",
        border: `1px solid ${COLORS.border}`,
        borderRadius: 10,
        backgroundColor: COLORS.field
      },
      formControl: {
        "label + &": {
          marginTop: 20
        }
      },
      focused: {
        borderColor: COLORS.primary,
        backgroundColor: "#fff"
      },
      error: {
        borderColor: COLORS.error
      },
      // multi-line fields otherwise drop the side padding
      multiline: {
        padding: "10px 12px"
      },
      underline: {
        "&:before, &:after": {
          display: "none"
        }
      }
    },
    MuiInputLabel: {
      formControl: {
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(13px, 35px) scale(1)"
      },
      shrink: {
        transform: "translate(0, 0) scale(0.85)"
      }
    },
    MuiTableRow: {
      root: {
        height: 52,
        "&$hover:hover": {
          backgroundColor: COLORS.field
        }
      },
      head: {
        height: 44,
        backgroundColor: COLORS.field
      }
    },
    MuiTableCell: {
      root: {
        borderBottom: `1px solid ${COLORS.grid}`
      },
      head: {
        borderBottom: `1px solid ${COLORS.border}`,
        color: COLORS.muted,
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0.3,
        textTransform: "uppercase"
      },
      body: {
        color: COLORS.text,
        fontSize: 14
      }
    },
    MuiTablePagination: {
      input: {
        padding: 0,
        border: 0,
        backgroundColor: "transparent"
      }
    },
    MuiTableSortLabel: {
      root: {
        "&:hover": {
          color: COLORS.primary
        }
      },
      active: {
        color: COLORS.primary
      }
    }
  }
};
